import { axios } from '../util/axios'

const API_ENDPOINT = '/v1/attempts/check'
const API_ENDPOINT_V2 = '/v2/attempts/check'
const API_ENDPOINT_SPLIT_LOGIN_EMAIL = '/v3/attempts/check'
const API_ENDPOINT_REVALIDATION = '/v4/attempts/check'
const API_ENDPOINT_2FA = '/2fa/attempts/check'

export default () =>
  axios
    .get(API_ENDPOINT, { withCredentials: true })
    .then(res => res.data.remaining_time)
    .catch(err => err)

export const getAttemptCheck = () =>
  axios
    .get(API_ENDPOINT, { withCredentials: true })
    .then(res => res.data)
    .catch(err => err)

export const getAttemptCheckv2 = token => {
  if (!token)
    return new Promise((resolve, reject) => {
      return reject('No token')
    })
  return axios
    .get(API_ENDPOINT_V2, {
      withCredentials: false,
      headers: {
        Authorization: token,
      },
    })
    .then(res => res.data)
    .catch(err => err)
}

export const splitLoginEmailCheckAttempts = token => {
  if (!token)
    return new Promise((resolve, reject) => {
      return reject('No token')
    })
  return axios
    .get(API_ENDPOINT_SPLIT_LOGIN_EMAIL, {
      withCredentials: false,
      headers: {
        Authorization: token,
      },
    })
    .then(res => res.data)
    .catch(err => err)
}

export const revalidationCheckAttempts = token => {
  if (!token)
    return new Promise((resolve, reject) => {
      return reject('No token')
    })
  return axios
    .get(API_ENDPOINT_REVALIDATION, {
      withCredentials: false,
      headers: {
        Authorization: token,
      },
    })
    .then(res => res.data)
    .catch(err => err)
}

export const getAttemptCheck2FA = token => {
  if (!token)
    return new Promise((resolve, reject) => {
      return reject('No token')
    })
  return axios
    .get(API_ENDPOINT_2FA, {
      withCredentials: false,
      headers: {
        Authorization: token,
      },
    })
    .then(res => res.data)
    .catch(err => err)
}
